import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Backdrop,
  CircularProgress,
  Button,
} from "@mui/material";
import api from "../services/api";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const PaymentReport = () => {
  const rows1 = [
    {
      applycat: "B",
      form_submitted: 819,
      form_not_submitted: 150,
    },
    {
      applycat: "E",
      form_submitted: 73,
      form_not_submitted: 18,
    },
    {
      applycat: "NaN",
      form_submitted: 2,
      form_not_submitted: 0,
    },
    {
      applycat: "Q",
      form_submitted: 894,
      form_not_submitted: 168,
    },
  ];
  const [backDropLoading, setBackDropLoading] = useState(false);
  const navigate = useNavigate();

  const specialTotal1 = { payment: 1330, submit: 796 };
  const [paymentDetails, setPaymentDetails] = useState([]);
  // const Realdata = [
  //   { applycat: "B", form_submitted: "7", form_not_submitted: "7" },
  //   { applycat: "C", form_submitted: "278", form_not_submitted: "619" },
  //   { applycat: "E", form_submitted: "12", form_not_submitted: "11" },
  //   { applycat: "NaN", form_submitted: "0", form_not_submitted: "13" },
  //   { applycat: "R", form_submitted: "26", form_not_submitted: "127" },
  //   { applycat: "Q", form_submitted: "5", form_not_submitted: "6" },
  // ];

  const transformExamSummaryData = (data) => {
    const applycatMap = {
      C: "COMPARTMENTAL",
      B: "BETTERMENT",
      E: "EX-REGULAR",
      R: "REGULAR",

      Q: "SINGLE-SUBJECT(ENGLISH)",
      NAN: "NAN",
    };

    const defaultCategories = [
      "COMPARTMENTAL",
      "REGULAR",
      "EX-REGULAR",
      "BETTERMENT",
      "SINGLE-SUBJECT(ENGLISH)",
      "NAN",
    ];

    // Prepare a map with default zero values
    const summaryMap = defaultCategories?.reduce((acc, key) => {
      acc[key] = { category: key, payment: 0, submit: 0 };
      return acc;
    }, {});

    data.forEach(({ applycat, form_submitted, form_not_submitted }) => {
      const category = applycatMap[applycat] || "NAN";

      const payment = Number(form_submitted) + Number(form_not_submitted);
      const submit = Number(form_submitted);

      if (!summaryMap[category]) {
        summaryMap[category] = { category, payment: 0, submit: 0 };
      }

      summaryMap[category].payment += payment;
      summaryMap[category].submit += submit;
    });

    const rows = Object.values(summaryMap);

    const total = rows.reduce(
      (acc, item) => {
        acc.payment += item.payment;
        acc.submit += item.submit;
        return acc;
      },
      { payment: 0, submit: 0 }
    );

    const specialTotal = rows
      .filter((item) => item.category !== "COMPARTMENTAL")
      .reduce(
        (acc, item) => {
          acc.payment += item.payment;
          acc.submit += item.submit;
          return acc;
        },
        { payment: 0, submit: 0 }
      );

    return {
      rows,
      total,
      specialTotal,
    };
  };

  const { rows, total, specialTotal } =
    transformExamSummaryData(paymentDetails);
  console.log(total, "total");
  const dashboardData = async () => {
    try {
      setBackDropLoading(true);
      const response = await api.get(`compartment/compartment-summary`);
      // console.log(response, "response");

      setPaymentDetails(response.data?.data);
    } catch (error) {
      toast.error(
        error?.response?.data?.error ?? "Error fetching data. Please try again."
      );
    } finally {
      setBackDropLoading(false);
    }
  };
  useEffect(() => {
    dashboardData();
  }, []);

  const handlePrint = () => {
    window.print();
  };
  return (
    <>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        mb={1}
        mt={2}
      >
        <Box textAlign="center">
          <img
            src="./full-logo.png"
            alt="Bihar Board Examination"
            title="Bihar Board Examination"
            style={{ maxWidth: "100%", height: "68px" }}
          />
        </Box>
      </Box>
      <div style={{ height: "54px", backgroundColor: "#8C0001" }} />

      <Box
        p={2}
        style={{
          width: "60%",
          textAlign: "center",
          margin: "0 auto",
        }}
      >
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>Exam Category</strong>
                </TableCell>
                <TableCell align="center">
                  <strong>Payment</strong>
                </TableCell>
                <TableCell align="center">
                  <strong>Final Submit</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows?.map((row) =>
                row?.category === "COMPARTMENTAL" ? (
                  <TableRow key={row.category}>
                    <TableCell>{row?.category}</TableCell>
                    <TableCell align="center">{row?.payment}</TableCell>
                    <TableCell align="center">{row?.submit}</TableCell>
                  </TableRow>
                ) : null
              )}

              <TableRow>
                <TableCell colSpan={3} align="center">
                  <Typography variant="h6">Special</Typography>
                </TableCell>
              </TableRow>

              {rows?.map((row) =>
                row?.category !== "COMPARTMENTAL" ? (
                  <TableRow key={row.category}>
                    <TableCell>
                      {row?.category === "NAN"
                        ? "NOT DEFINED CATEGORY"
                        : row?.category}
                    </TableCell>
                    <TableCell align="center">{row?.payment}</TableCell>
                    <TableCell align="center">{row?.submit}</TableCell>
                  </TableRow>
                ) : null
              )}
              <TableRow>
                <TableCell>
                  <strong>Total</strong>
                </TableCell>
                <TableCell align="center">
                  <strong>{specialTotal?.payment}</strong>
                </TableCell>
                <TableCell align="center">
                  <strong>{specialTotal?.submit}</strong>
                </TableCell>
                {/* <TableCell align="center">
                  <strong>{total?.payment}</strong>
                </TableCell>
                <TableCell align="center">
                  <strong>{total?.submit}</strong>
                </TableCell> */}
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        <Box mt={4}>
          <Typography variant="h6" align="center">
            Total
          </Typography>
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>
                    <strong
                      style={{
                        visibility: "hidden",
                      }}
                    >
                      Exam Category total special
                    </strong>
                  </TableCell>

                  <TableCell align="center">
                    <strong>Payment</strong>
                  </TableCell>
                  <TableCell align="center">
                    <strong>Final Submit</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <strong>Total</strong>
                  </TableCell>
                  <TableCell align="center">
                    <strong>{total?.payment}</strong>
                  </TableCell>
                  <TableCell align="center">
                    <strong>{total?.submit}</strong>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        <Box
          sx={{
            pt: 2,
            textAlign: "center",

            mt: 2,
          }}
          className="no-print"
        >
          {/* Apply Button */}
          <Box sx={{ mt: 2 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate(`/dashboard`);
              }}
              sx={{
                px: 4,
              }}
            >
              Back
            </Button>

            <Button
              variant="contained"
              color="primary"
              onClick={handlePrint}
              sx={{
                marginLeft: 4,
              }}
            >
              Print
            </Button>
          </Box>
        </Box>
        <Backdrop
          open={backDropLoading}
          style={{ zIndex: 1300, color: "#fff" }}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </Box>
    </>
  );
};

export default PaymentReport;
